import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FeedbackIcon from '@material-ui/icons/Feedback';

import styles from './ChatInputError.css';


const ChatInputError = (props) => {
  const { isDesktop, message } = props;

  const wrapperClass = classNames({
    [styles.errorWrapperDesktop]: isDesktop,
    [styles.errorWrapper]: !isDesktop,
  });

  return (
    <div className={wrapperClass}>
      <FeedbackIcon className={styles.errorIcon} />
      <span className={styles.errorMessage}>
        {message}
      </span>
    </div>
  );
};

ChatInputError.propTypes = {
  isDesktop: PropTypes.bool,
  message: PropTypes.string,
};

ChatInputError.defaultProps = {
  isDesktop: false,
  message: null,
};

export default ChatInputError;
